const cacheConfig = require('./cacheConfig');
const catalogsAvailable = require('./catalogsAvailable');

module.exports = {
  cacheConfig,
  catalogsAvailable,
};
